export const API_VERSION = 'v2';
export const CLIENT_VERSION = 'v2';
